import { DEFAULT_TIMELOCK_STAKING_MIN_VALUE } from "@bundles/consts";
import FundsService from "@services/Funds.service";
import { setApiMe } from "@features/action.bfapp";
import store from "@features/store";
import React, {
  createContext,
  useContext,
  useState,
  PropsWithChildren,
  useEffect,
} from "react";
import { useTabsLogic } from "./hooks/useTabsLogis";

export const trackTabsOptions = [
  {
    label: "Track1",
    value: "track_1",
  },
  {
    label: "Track 2",
    value: "track_2",
  },
];

type MembershipPageContextType = {
  timelockMinValue: number;
  isInvestmentPlatformAccordionOpen: boolean;
  setInvestmentPlatformAccordionOpen: (isOpen: boolean) => void;
  isTrackProgressAccordionOpen: boolean;
  setIsTrackProgressAccordionOpen: (isOpen: boolean) => void;
  activeTrackTab: string;
  handleChangeActiveTrackTab: (tab: string) => void;
};

const MembershipPageContext = createContext<
  MembershipPageContextType | undefined
>(undefined);

export const MembershipPageProvider = ({
  children,
}: PropsWithChildren<unknown>) => {
  const {
    activeTab: activeTrackTab,
    handleChangeActiveTab: handleChangeActiveTrackTab,
  } = useTabsLogic(trackTabsOptions);

  const [
    isInvestmentPlatformAccordionOpen,
    setInvestmentPlatformAccordionOpen,
  ] = useState(false);

  const [isTrackProgressAccordionOpen, setIsTrackProgressAccordionOpen] =
    useState(false);

  const [minValue, setMinValue] = useState(DEFAULT_TIMELOCK_STAKING_MIN_VALUE);

  useEffect(() => {
    store.dispatch(setApiMe(true));
    FundsService.getTimelockStakingSettings().then((resp) => {
      setMinValue((prev) => resp?.data?.timelock_tier_threshold_amount ?? prev);
    });
  }, []);

  return (
    <MembershipPageContext.Provider
      value={{
        timelockMinValue: minValue,
        isInvestmentPlatformAccordionOpen,
        setInvestmentPlatformAccordionOpen,
        isTrackProgressAccordionOpen,
        setIsTrackProgressAccordionOpen,
        activeTrackTab,
        handleChangeActiveTrackTab,
      }}
    >
      {children}
    </MembershipPageContext.Provider>
  );
};

export const useMembershipPageContext = () => {
  const context = useContext(MembershipPageContext);
  if (!context) {
    throw new Error(
      "useMembershipPageContext must be used within a MembershipPageProvider"
    );
  }
  return context;
};
